import React, { useState, useEffect } from 'react';
import '../../App.css';
import { lanoService } from "../../api/lanoService";

export default function LanoIds() {
  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(null);
  const [prev, setPrev] = useState(null);
  const [lanoToken, setLanoToken] = useState(null);
  const [error, setError] = useState(null);

  // Function to load the freelancers data
  const loadFreelancersData = async () => {
    setLoading(true);
    setError(null);
    try {
      // Get Lano authentication token
      const token = await lanoService.getAuthToken();
      setLanoToken(token);
      
      // Fetch freelancers data
      await fetchFreelancers(token);
    } catch (error) {
      console.error('Error initializing Lano data:', error);
      setError('Failed to load Lano data. Please try again later.');
      setLoading(false);
    }
  };

  const fetchFreelancers = async (token) => {
    const authToken = token || lanoToken;
    if (!authToken) {
      console.error('No Lano token available');
      setError('Authentication token not available. Please refresh the page.');
      return;
    }

    try {
      // Use lanoService to get company freelancers
      const responseJson = await lanoService.getCompanyFreelancers(authToken);
      
      if (responseJson.links && responseJson.links.first) {
        loadFreelancerPage(responseJson.links.first, [], authToken);
      } else {
        setData(responseJson.data || []);
        setPrev(responseJson.links?.prev || null);
        setLoading(false);
      }
    } catch (error) {
      console.error('Error fetching freelancers:', error);
      setError('Failed to fetch freelancers. Please try again later.');
      setLoading(false);
    }
  };

  const loadFreelancerPage = async (pageUrl, currentData, token) => {
    const authToken = token || lanoToken;
    if (!authToken) {
      console.error('No Lano token available');
      setError('Authentication token not available. Please refresh the page.');
      return;
    }

    try {
      // Use lanoService to get the specific page of freelancers
      const responseJson = await lanoService.getCompanyFreelancersPage(authToken, pageUrl);
      
      // Update the current page number if the 'meta' property exists
      if (Object.prototype.hasOwnProperty.call(responseJson, "meta")) {
        setCurrentPage(responseJson.meta.currentPage);
      }
      
      setPrev(responseJson.links?.prev || null);
      // Update the data
      setData([...(currentData || []), ...responseJson.data]);
      setLoading(false);
    } catch (error) {
      console.error('Error loading freelancers page:', error);
      setError('Failed to load freelancers data. Please try again later.');
      setLoading(false);
    }
  };

  const loadMore = () => {
    if (prev) {
      setLoading(true);
      loadFreelancerPage(prev, data, lanoToken);
    }
  };

  useEffect(() => {
    // Load freelancers data when component mounts
    loadFreelancersData();
  }, []);

  // Sort data by freelancer.id in descending order
  const sortedData = data.sort((a, b) => b.id - a.id);

  const freelancerItems = sortedData.map((freelancer) => (
    <div className='list-tasks-item' key={freelancer.id}>
      <div style={{ flexBasis: '200px' }}>{freelancer.id}</div>
      <div style={{ flexBasis: '200px' }}>{freelancer.attributes.fullName}</div>
      <div style={{ flexBasis: '300px' }}>{freelancer.attributes.email}</div>
      <div style={{ flexBasis: '200px' }}>{freelancer.attributes.companyName || 'N/A'}</div>
      <div style={{ flexBasis: '100px' }}>{freelancer.attributes.isVendor ? 'Yes' : 'No'}</div>
      <div style={{ flexBasis: '100px' }}>{freelancer.attributes.hidden ? 'Yes' : 'No'}</div>
    </div>
  ));

  return (
    <>
      <div className="content-wrapper page">
        <div className='content-wrapper'>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '60px' }}>
            <h1>All Freelancers</h1>
            <button className='big-button' onClick={() => loadFreelancersData()}>Refresh</button>
          </div>
        </div>
        
        {error && (
          <div className="error-message" style={{ color: 'red', textAlign: 'center', margin: '10px 0' }}>
            {error}
          </div>
        )}
        
        <div className='content-wrapper content-wrapper-talent-list'>
          <div className='list-tasks-header'>
            <div style={{ flexBasis: '200px' }}>Lano ID</div>
            <div style={{ flexBasis: '200px' }}>Full Name</div>
            <div style={{ flexBasis: '300px' }}>Email</div>
            <div style={{ flexBasis: '200px' }}>Company Name</div>
            <div style={{ flexBasis: '100px' }}>Is Vendor</div>
            <div style={{ flexBasis: '100px' }}>Hidden</div>
          </div>
          {isLoading ? (
            <div style={{ textAlign: 'center', padding: '20px' }}>Loading freelancers...</div>
          ) : (
            <div style={{ marginBottom: "30px" }}>
              {freelancerItems.length > 0 ? freelancerItems : <div style={{ textAlign: 'center', padding: '20px' }}>No freelancers found</div>}
            </div>
          )}
        </div>
        <div className='content-wrapper'>
          {prev && !isLoading && (
            <button className='big-button' onClick={() => loadMore()}>Load More</button>
          )}
        </div>
      </div>
    </>
  );
}
